import React, { useEffect } from 'react';

export default function AgencyUserDrawer({
  open,
  title,
  subtitle,
  onClose,
  children,
  footer,
  width = 'min(520px, 100vw)',
}) {
  useEffect(() => {
    if (!open) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="nf-ws-drawer-root" role="presentation">
      <button type="button" className="nf-ws-drawer-backdrop" aria-label="Close panel" onClick={onClose} />
      <aside
        className="nf-ws-drawer is-open"
        role="dialog"
        aria-modal="true"
        aria-labelledby="nf-ws-drawer-title"
        style={{ width }}
      >
        <header className="nf-ws-drawer-header">
          <div>
            <h2 id="nf-ws-drawer-title">{title}</h2>
            {subtitle ? <p>{subtitle}</p> : null}
          </div>
          <button type="button" className="nf-btn nf-btn-secondary nf-btn-xs" onClick={onClose} aria-label="Close">
            <i className="fas fa-times" />
          </button>
        </header>
        <div className="nf-ws-drawer-body">{children}</div>
        {footer ? <footer className="nf-ws-drawer-footer">{footer}</footer> : null}
      </aside>
    </div>
  );
}
